export default __webpack_public_path__ + "images/0880d71a7472f1e574c124fbd3184faf-pride_collections_touchpoint_image.webp";